"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InquirySource = exports.InquiryStage = exports.InquiryType = exports.PriceType = void 0;
var PriceType;
(function (PriceType) {
    PriceType["MONTHLY"] = "monthly";
    PriceType["WEEKLY"] = "weekly";
    PriceType["DAILY"] = "daily";
})(PriceType = exports.PriceType || (exports.PriceType = {}));
var InquiryType;
(function (InquiryType) {
    InquiryType["Cart"] = "cart";
    InquiryType["Freeform"] = "freeform";
    InquiryType["InventoryBooking"] = "inventory-booking";
    InquiryType["Sales"] = "sales";
    InquiryType["Finance"] = "finance";
    InquiryType["Operations"] = "operations";
    InquiryType["Logistics"] = "logistics";
    InquiryType["Marketing"] = "marketing";
    InquiryType["Contact"] = "contact";
    InquiryType["TenderdTrackTelematicsRequest"] = "tenderd_track_telematics_request";
})(InquiryType = exports.InquiryType || (exports.InquiryType = {}));
var InquiryStage;
(function (InquiryStage) {
    InquiryStage["Created"] = "created";
    InquiryStage["Processing"] = "processing";
    InquiryStage["Scheduled"] = "scheduled";
    InquiryStage["Delivered"] = "delivered";
    InquiryStage["Cancelled"] = "cancelled";
})(InquiryStage = exports.InquiryStage || (exports.InquiryStage = {}));
var InquirySource;
(function (InquirySource) {
    InquirySource["Marketplace"] = "Marketplace";
    InquirySource["CustomInquiry"] = "CustomInquiry";
    InquirySource["ContactUs"] = "ContactUs";
})(InquirySource = exports.InquirySource || (exports.InquirySource = {}));
//# sourceMappingURL=inquiry.js.map